import React, { Component } from 'react'
import styled from 'styled-components'
import { observer } from 'mobx-react'

import store from '../store/'
import Name from './Name'

const Container = styled.div`
  height: 200vh;

  transition: opacity 0.3s ease-in-out;
  opacity: ${props => props.opacity};
`

@observer
export default class Hero extends Component {
  render() {
    return (
      <Container opacity={store.visibleSection.hero ? 1 : 0}>
        <Name />
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Hero.js